import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';

import agent from '../api/agent';
import { roleSettingType } from '../api/types';
import { RolesAndPermissionsID } from './../models/rolesAndPermissions';

export default class RolesAndPermissionsIDStore {
  rolesIDRegistry = new Map<string, RolesAndPermissionsID>();
  roleSetting: roleSettingType[] = [];
  loadingInitial = false;
  loadingApi = false;
  roleAndPermissionItemId: string[] = [];
  modeRoleId: any;
  constructor() {
    makeAutoObservable(this);
  }

  get rolesIDs() {
    return Array.from(this.rolesIDRegistry.values());
  }
  private setRolesIDs = (roleIdDetails: RolesAndPermissionsID) => {
    this.rolesIDRegistry.set(roleIdDetails.id, roleIdDetails);
  };
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  loadRoleSetting = async () => {
    try {
      this.loadingInitial = true;
      const roleSettings = await agent.Role.roleSetting();
      runInAction(() => {
        this.roleSetting = roleSettings.data;
      });
      this.loadingInitial = false;
    } catch {
      toast.error('Oops ! Something went wrong');
      this.loadingInitial = false;
    }
  };

  loadRoleIDS = async () => {
    this.loadingInitial = true;
    try {
      if (this.rolesIDRegistry.size <= 1) {
        const roleDetails = await agent.RoleIDs.roleIDs();

        roleDetails.forEach((roleDetails) => {
          runInAction(() => {
            this.setRolesIDs(roleDetails);
          });
        });

        roleDetails.forEach((item: RolesAndPermissionsID) => {
          this.roleAndPermissionItemId.push(item.itemId);
        });
      }
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };
  loadRoleIDS2 = async (id: string) => {
    this.loadingApi = true;
    try {
      this.modeRoleId?.clear();
      const roleDetails = await agent.RoleIDs.roleIDs2(id);
      this.modeRoleId = roleDetails;
      roleDetails.forEach((roleDetails) => {
        runInAction(() => {
          this.setRolesIDs(roleDetails);
        });
      });
      this.loadingApi = false;
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  createRoleID = async (roleID: RolesAndPermissionsID) => {
    this.loadingInitial = true;
    try {
      await agent.RoleIDs.createRoleIDs(roleID);
      runInAction(() => {
        this.rolesIDRegistry.set(roleID.id, roleID);
      });

      toast.success('Record  Enabled  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  ////////////////////////only for cloning
  cloneRoleID = async (roleID: RolesAndPermissionsID) => {
    this.loadingInitial = true;
    try {
      await agent.RoleIDs.createRoleIDs(roleID);
      runInAction(() => {
        this.rolesIDRegistry.set(roleID.id, roleID);
      });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };

  deleteRoleID = async (id: string) => {
    try {
      await agent.RoleIDs.deleteRoleIDS(id);
      runInAction(() => {
        this.rolesIDRegistry.delete(id);
      });
      toast.success('Record Disabled Succesfully.');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
  roleIdMode = async (id: string, mode: number) => {
    try {
      await agent.Role.modes(id, mode);
      return 'success';
    } catch (error) {
      console.log(error);
    }
  };
  rolechangesMode = (item: any) => {
    this.setRolesIDs(item);
  };
}
